import React, { useState } from "react";
import { Link } from "react-router-dom";
import Menu from "../images/menu.png";

const Sidebar = () => {
  const [showMenu, setShowMenu] = useState(false);
  let classMenu = 'display-menu';

  const displayMenu = () => {
    console.log('oli')
    setShowMenu(!showMenu);
  }

  return (
    <div className="sidebar">
      <div className="sidebar-name bg-brown">
        <a href="https://fundacionmohme.org/especiales/memoria-2024/">
          <div className="sidebar-name-main">Fundación Gustavo Mohme Llona</div>
          <div className="sidebar-name-secondary">Memoria 2014-2024</div>
        </a>
        <div className="btn-menu" ><img src={Menu} onClick={displayMenu} alt="Menu" /></div>
      </div>
      <div className={showMenu ? classMenu + " sidebar-content" : "sidebar-content"}>
        <div className="bg-content bg-red">
          <div className="title-content color-red">
            <a href="https://fundacionmohme.org/especiales/memoria-2024/#nosotros">1. NOSOTROS</a>
          </div>
          <div>
            <p>
              <Link to="/gustavo-mohme-llona">
                1.1 Gustavo Mohme Llona (1930-2000)
              </Link>
            </p>
            <p>
              <Link to="/fundacion">1.2 La fundación</Link>
            </p>
          </div>
        </div>
        <div className="bg-content bg-blue">
          <div className="title-content color-blue">
            <a href="https://fundacionmohme.org/especiales/memoria-2024/#periodismo">2. EJE PERIODISMO Y DEMOCRACIA</a>
          </div>
          <div>
            <p>
              <Link to="/talleres-periodismo">
                2.1 Talleres sobre periodismo (actividades de formación)
              </Link>
            </p>
            <p>
              <Link to="/observatorio-universitario-medios">
                2.2 Observatorio Universitario de Medios
              </Link>
            </p>
            <p>
              <Link to="/cultura-digital">
                2.3 Sociedad de la información y cultura digital para la
                ciudadanía
              </Link>
            </p>
          </div>
        </div>
        <div className="bg-content bg-green">
          <div className="title-content color-green">
            <a href="https://fundacionmohme.org/especiales/memoria-2024/#educacion">3. EJE EDUCACIÓN Y CIUDADANÍA</a>
          </div>
          <div>
            <p>
              <Link to="/proyecto-democracia">
                3.1 Proyecto Democracia: construyendo ciudadanía desde la
                escuela
              </Link>
            </p>
            <p>
              <Link to="/debate-educacion">
                3.2 Debate sobre la educación como problema
              </Link>
            </p>
          </div>
        </div>
        <div className="bg-content bg-brown">
          <div className="title-content color-brown">
            <a href="https://fundacionmohme.org/especiales/memoria-2024/#otros">4. OTRAS INICIATIVAS</a>
          </div>
          <div>
            <p>
              <Link to="/participacion-ciudadana-tribunal-constitucional">
                4.1 Participación ciudadana en el proceso de selección de
                magistrados del Tribunal Constitucional
              </Link>
            </p>
            <p>
              <Link to="/premios-trayectoria">4.2 Premio a la Trayectoria</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
